import "font-awesome/css/font-awesome.min.css";
import { Route, Switch } from "react-router";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import NotFound from "../../shared/not-found/notFound";
import ControlledRoute from "../../security/controlledRoute";
import { getEffectiveRoutes } from "../../security/route";
import HomeLayout from "./layout/layout";
import { routes } from "./route/routes";

const DASHBOARD_ROUTING_ANIMATION = "fadeup";

const Dashboard: React.FC = () => {
  return (
    <HomeLayout>
      <TransitionGroup>
        <Switch>
          {getEffectiveRoutes(routes).map(({ path, Component, exact, roles }) => (
            <ControlledRoute key={path} exact={exact} path={`${path}`} roles={roles}>
              <CSSTransition in={true} timeout={0} classNames={DASHBOARD_ROUTING_ANIMATION} unmountOnExit>
                <div>
                  <Component />
                </div>
              </CSSTransition>
            </ControlledRoute>
          ))}
          <Route component={NotFound} />
        </Switch>
      </TransitionGroup>
    </HomeLayout>
  );
};

export default Dashboard;
